export default __webpack_public_path__ + "static/media/second.875dfecf.jpg";